import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { ConfirmOptions } from '../modal.model';

@Component({
  selector: 'sb-confirm-modal',
  templateUrl: './sb-confirm-modal.component.html',
  styleUrls: ['./sb-confirm-modal.component.scss'],
  standalone: false,
})
export class SbConfirmModalComponent implements OnInit {
  options: ConfirmOptions<any>;
  @Input()
  templateId: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as ConfirmOptions<any>;
  }

  constructor(private state: SbModalState) {}

  yes() {
    this.state.modals.get(this.templateId).close('YES');
  }

  no() {
    this.state.modals.get(this.templateId).close('NO');
  }
}
